import React from "react";
import DataGrid from "../../../../../dataGrid";
import GridConfig from "./gridConfig";
import { withStyles } from "@material-ui/core";
import styles from "../../../styles";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import StatusBar from "../../../../../dataGrid/StatusBar";
import { isEqual } from "lodash/lang";
import DropYardGridHeader from "./gridHeader";
import { getEquipmentsList, getFormattedData } from "./utils";

class DropYardGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      selectedDropYard: [],
      isDropYardSelectOnGrid: false,
      quickFilterText: "",
    };
  }

  componentDidMount() {
    this.reInitializeGridConfig();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.selectedDropYard, this.state.selectedDropYard)) {
      this.updateSelection();
    }

    if (!isEqual(this.props.data, prevProps.data)) {
      this.reInitializeGridConfig();
    }
  }

  reInitializeGridConfig() {
    const { trailers, tractors } = getEquipmentsList(this.props.data);
    this.gridConfig = new GridConfig({
      trailers,
      tractors,
    });
    this.forceUpdate(); // force re-render to apply new gridConfig
  }

  updateSelection = () => {
    if (this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (
          this.props.selectedDropYardId.length > 0 &&
          this.props.selectedDropYardId.includes(node.data.dropYardId)
        ) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: "selectionChanged",
        api: this.gridApi,
      });
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  constructStatusBar = () => {
    const totalDropYard = this.props.data.length;
    const statusBarData = [
      {
        label: totalDropYard + " DropYards",
        filterCondition: "",
      },
    ];
    return statusBarData;
  };

  updateGridData = (updatedFilterData) => {
    this.setState(
      {
        filterData: updatedFilterData,
      },
      () => this.gridApi.onFilterChanged()
    );
  };

  onSelectionChanged = () => {
    if (this.props.dropYardSelectedOnGrid && this.gridApi) {
      const selectedDropYard = this.gridApi
        .getSelectedRows()
        .map((anchor) => anchor);
      this.props.dropYardSelectedOnGrid(selectedDropYard);
      this.setState({ selectedDropYard: selectedDropYard });
    }
  };

  updateQuickFilterText = (value) => {
    this.setState({
      quickFilterText: value,
    });
  };

  getOptions = (terminalList) => {
    const terminalListOption = terminalList.map((terminal) => {
      return {
        label: terminal.terminalCode,
        value: terminal.terminalId,
      };
    });
    return [{ label: "All", value: "" }, ...terminalListOption];
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, error, data, terminalList, selectGridFilter} = this.props;
    const { selectedDropYard } = this.state;
    const formattedData = getFormattedData(data);
    return (
      <div className={classes.dropYardGridContainer}>
        <div className={classes.anchorPointModuleContainer}>
          <DropYardGridHeader
            selectedDropYard={selectedDropYard}
            updateQuickFilterText={this.updateQuickFilterText}
            selectGridFilter={selectGridFilter}
            terminalList={this.getOptions(terminalList || [])}
            gridApi={this.gridApi}
          />
          <div className={`${classes.dataGrid} ${classes.anchorPointContent}`}>
            <DataGrid
              defaultColDef={config.defaultColDef}
              columnDefs={config.columns}
              config={config}
              enableFilter={config.enableFilter}
              enableSorting={config.enableSorting}
              rowSelection={config.rowSelection}
              rowDeselection={config.rowDeselection}
              rowData={formattedData}
              onGridReady={this.onGridReady}
              onSelectionChanged={this.onSelectionChanged}
              onRowDataChanged={this.updateSelection}
              quickFilterText={this.state.quickFilterText}
              panelLabel={(filteredData) => (
                <StatusBar
                  data={this.constructStatusBar(filteredData)}
                  filterGridData={this.updateGridData}
                />
              )}
              showErrorMessage={error}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default compose(withStyles(styles), withSnackbar)(DropYardGrid);
